import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { HostingPlansState } from './types'
import { IPlan } from '@/types/plan.interface'
import getPlanWithExtraParams from '@/utils/helpers/get-plan-extra-params.helper'

const initialState: HostingPlansState = {
  list: [],
}

const hostingPlansSlice = createSlice({
  name: 'hosting-plans',
  initialState,
  reducers: {
    setHostingPlans: (state, action: PayloadAction<IPlan[]>) => {
      state.list = action.payload.map((plan) => getPlanWithExtraParams(plan))
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.hostingPlans,
      }
    })
  },
})

export const { setHostingPlans } = hostingPlansSlice.actions

export default hostingPlansSlice
